import { render, staticRenderFns } from "./ActiveTicketList.vue?vue&type=template&id=2730d2e9"
import script from "./ActiveTicketList.vue?vue&type=script&lang=js"
export * from "./ActiveTicketList.vue?vue&type=script&lang=js"
import style0 from "./ActiveTicketList.vue?vue&type=style&index=0&id=2730d2e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports